/**
 * This was create specifically to detect "clicks" on the mv-video-target divs on mobile devices.
 * Listening for regular clicks was being broken by something in video.js
 *
 * This function will take an element and a callback function.  If a user taps the element, this will execute the callback.
 * A tap is touching the element, then releasing the touch without triggering a `touchmove` event.
 * @param element
 * @param callback
 */
export function onMobileTapClick(element: Element, callback: Function): void {
  // started tap/touch on player
  let tapTriggerValid = false

  function onTouchMove() {
    tapTriggerValid = false
    window.removeEventListener('touchmove', onTouchMove)
  }

  function onTouchEnd() {
    // if no scrolling happened, tap with no scroll is valid and triggered
    if (tapTriggerValid) {
      callback()
    }
    element.removeEventListener('touchend', onTouchEnd)
    window.removeEventListener('touchmove', onTouchMove)
  }

  element.addEventListener('touchstart', (ev) => {
    tapTriggerValid = true

    // scroll anywhere will cancel
    window.addEventListener('touchmove', onTouchMove)

    // tap/touch ended
    element.addEventListener('touchend', onTouchEnd)
  })
}
